import { errorByCode } from "./errors";
import { auth, db } from "./app";

const SIGNUP_SAFE_PAYLOAD_ATTRS = [
  "gender",
  "lastname",
  "firstname",
  "company",
  "activity",
  "address",
  "city",
  "postalCode",
  "country",
  "email"
];

const userSafePayload = payload => {
  return SIGNUP_SAFE_PAYLOAD_ATTRS.reduce((acc, attr) => {
    acc[attr] = payload[attr] || "";
    return acc;
  }, {});
};

export async function fetch(uid) {
  let error, user;

  try {
    const doc = await db
      .collection("users")
      .doc(uid)
      .get();

    const { claims, token } = await auth.currentUser.getIdTokenResult();
    const admin = claims.admin;

    user = { ...doc.data(), admin, uid, token };
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error, user };
}

export function* updateUserHasVisited() {
  let error;
  const user = auth.currentUser;

  try {
    yield db
      .collection("users")
      .doc(user.uid)
      .update({
        hasVisited: true
      });
  } catch ({ code, message }) {
    error = errorByCode(code);
  }

  return { error };
}

export function* update(payload) {
  let error, user;
  const { email, password } = payload;
  const userPayload = userSafePayload(payload);
  const authUser = auth.currentUser;

  try {
    // update auth email
    if (email) {
      yield authUser.updateEmail(email);
    }

    // update auth password
    if (password) {
      yield authUser.updatePassword(password);
    }

    // update db user
    yield db
      .collection("users")
      .doc(authUser.uid)
      .set(userPayload);

    // set user to return
    user = userPayload;
  } catch ({ code, message }) {
    if (code === "auth/requires-recent-login") {
      error = code;
    } else {
      error = errorByCode(code);
    }
  }

  return { error, user };
}

export function* destroy() {
  const user = auth.currentUser;
  let error;

  try {
    yield user.delete();
    // yield db.collection("users").doc(user.uid).delete()
  } catch ({ code, message }) {
    console.log("error", message);
    error = errorByCode(code);
  }

  return { error };
}



// WEBPACK FOOTER //
// ./src/services/firebase/user.js